import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

export const TextField = ({ ...props }: MuiTextFieldProps) => {
  return <MuiTextField {...(props as MuiTextFieldProps)} variant="outlined" />;
};
